/** File extensions supported by upload forms */

type Ext = `.${string}`

export const lossyImageExtensions: ReadonlyArray<Ext> = ['.jpg', '.jpeg', '.webp']
export const losslessImageExtensions: ReadonlyArray<Ext> = ['.gif', '.png']

/** Note: Some platforms have (security) issues with .svg, e.g. WP */
export const vectorImageExtensions: ReadonlyArray<Ext> = ['.svg']
export const bitmapFileExtensions: ReadonlyArray<Ext> = [...lossyImageExtensions, ...losslessImageExtensions]
export const videoFileExensions: ReadonlyArray<Ext> = ['.mov', '.mp4', '.webm', '.mpeg', '.m4v']
export const browserSafeImageExtensions: ReadonlyArray<Ext> = ['.jpg', '.png', '.gif', '.webp']

// Specific file formats
export const wordFileExtensions: ReadonlyArray<Ext> = ['.doc', '.docx']
export const csvFileExtensions: ReadonlyArray<Ext> = ['.csv']
export const excelFileExtensions: ReadonlyArray<Ext> = ['.xls', '.xlsx']
export const tableFileExtensions: ReadonlyArray<Ext> = [...csvFileExtensions, ...excelFileExtensions]
export const powerpointFileExtensions: ReadonlyArray<Ext> = ['.ppt', '.pptx']
export const pdfFileExtensions: ReadonlyArray<Ext> = ['.pdf']
export const photoshopFileExtensions: ReadonlyArray<Ext> = ['.psd']
export const illustratorFileExtensions: ReadonlyArray<Ext> = ['.ai', '.esp']

// TODO: Is it safe to put the above here?
export const binaryFileExtensions: ReadonlyArray<Ext> = [
  '.doc',
  '.docx',
  '.pdf',
  '.xls',
  '.xlsx',
  '.csv',
  '.txt',
  '.zip',
]
